/**
 * Setup a pager callback handler, which is aware of the container.
 * @param {HTMLElement} $container
 * @param {HTMLElement} $pager
 */
function makePagerCallback($container, $pager) {
    const mode = $pager.dataset.pagerMode;

    const pageTotals = {
        mobile: parseInt(getComputedStyle($container).getPropertyValue('--mobile-pages')) || 0,
        tablet: parseInt(getComputedStyle($container).getPropertyValue('--tablet-pages')) || 0,
        desktop: parseInt(getComputedStyle($container).getPropertyValue('--desktop-pages')) || 0,
    };

    // No mode determined, remove the pager...
    if (!mode) {
        $pager.remove();
        return;
    }

    const $buttons = $pager.querySelectorAll('button');
    const $prevButton = $pager.querySelector('button[data-pager-direction="previous"]');
    const $nextButton = $pager.querySelector('button[data-pager-direction="next"]');


    return event => {
        const $button = event.target.closest('button');

        // ???? Bail...
        if (!$button) {
            return;
        }

        const direction = $button.dataset.pagerDirection;

        // Hard bail, this shouldn't have happened.
        if (!direction) {
            $pager.remove();
            return;
        }

        const currentPage = parseInt(getComputedStyle($container).getPropertyValue(`--current-${mode}-page`) || 0);

        // Determine the next page, clamping for the logical min/max.
        let targetPage = currentPage + (direction === 'previous' ? -1 : 1);
        if (targetPage < 0) {
            targetPage = 0;
        }

        if (targetPage >= pageTotals[mode]) {
            targetPage = pageTotals[mode] - 1;
        }

        // Set the current page CSS var...
        $container.style.setProperty(`--current-${mode}-page`, targetPage.toString());

        // Set button states...
        $buttons.forEach($button => $button.setAttribute('disabled', 'disabled'));

        if (targetPage > 0) {
            $prevButton?.removeAttribute('disabled');
        }

        if (targetPage < pageTotals[mode] - 1) {
            $nextButton?.removeAttribute('disabled');
        }

    };
}

/**
 * Sets up an event list container.
 * @param {HTMLElement} $container
 */
function setupContainer($container) {
    // For now, we only care about paginated ones...
    if (!$container.matches('.agend-events-list--paginated')) {
        return;
    }

    const $pagers = $container.querySelectorAll('.agend-events-list__pager');

    if ($pagers.length === 0) {
        return;
    }

    // Bind pagination click events.
    $pagers.forEach($pager => {
        $pager.addEventListener('click', makePagerCallback($container, $pager));

        // And also click the first "prev" button to init states/etc.
        $pager.querySelector('button')?.click();
    });


}

document.addEventListener('DOMContentLoaded', event => {
    const $candidates = document.querySelectorAll('.agend-events-list');

    if (!$candidates.length) {
        return;
    }

    $candidates.forEach($candidate => setupContainer($candidate));
});
